import { groupBy, pipe, values, prop, path } from 'ramda'

import { sortClasses, sortDirectionWith } from 'app/common/lib/sort'

export const sortByClassThenName = <O extends object>(
  classKey: string,
  nameKey: string,
  data: Array<O>,
): Array<O> => {
  const res = pipe(
    groupBy<O, string>((item: O) =>
      typeof item[classKey] === 'string' ? item[classKey] : 'unknown',
    ),
    values,
    sortClasses<O>('down', path<any>([0, classKey])),
    (arr) => arr.map((group) => sortDirectionWith('down', prop<string>(nameKey), group)),
    (arr) => arr.flat(),
  )(data)
  return res
}
